import React from 'react';
import { candiesByIndex } from '../../../enums';

export /**
 Hash Popup Game Part
 */
const CheckHashPopupTopPart = ({ roundData }) => {
  return (
    <div className='results-block-wheel'>
      <div className='results-block-holder'>
        {roundData && (
          <>
            <img src={candiesByIndex[roundData.candy]} alt='' />
            <div className='results-block-small-circle'>
              <img src={candiesByIndex[roundData.multiplierCandy]} alt='' />
              <p className='results-block-small-circle-coef'>{`x${roundData.multiplierOdd}`}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
